import JSEncrypt from 'jsencrypt';

const RAS_ENCRYPT = new JSEncrypt();
let rsaPublicKey = '';

export async function rsaEncrypt(
  str: string,
  publicKey: string | (() => string | Promise<string>),
): Promise<string> {
  if (!rsaPublicKey) {
    rsaPublicKey = typeof publicKey === 'string' ? publicKey : await publicKey();
    RAS_ENCRYPT.setPublicKey(rsaPublicKey);
  }
  return RAS_ENCRYPT.encrypt(str) as string;
}
